import type { ButtonProps } from './types'

import { LoadingGrid } from '../LoadingGrid'

import * as S from './styles'

export const Button = ({ width, variant, rightIcon, children, loading, colorType, ...rest }: ButtonProps) => {
  return (
    <S.Button
      variant={variant}
      style={{
        width: width || '100%'
      }}
      colorType={colorType}
      {...rest}
    >
      <S.Text className="button-text" style={{ visibility: loading ? 'hidden' : 'visible' }}>
        {rightIcon} {children}
      </S.Text>

      {loading && (
        <S.LoadingOverlay>
          <LoadingGrid
            hasText={false}
            size="small"
            colorType={colorType === 'solidBlue' || colorType === 'solidGreen' ? 'solid' : 'outline'}
          />
        </S.LoadingOverlay>
      )}
    </S.Button>
  )
}
